<template>
  <div class="card">
    <div class="card-body">
      <h2 class="card-title">Notifications</h2>
      You have no notifications.
    </div>
  </div>
</template>

<script>
export default {};
</script>
